<template>

	<div v-if="features.enhancedSearch" :class="wrapperClasses" class="wpr search-results-wrapper">

		<!-- Toggle Button -->
		 <div class="search-results">

				<!-- <div v-if="hits.length"  class="toggle-container">
					<tiledviewToggle/>
				</div> -->
			<div v-if="!hits.length && !loading" class="no-results"> <div v-if="anyFilterSelected">
					{{ content.search.noResultsForDiscountSearch1 }}&nbsp;
          <div>{{ content.search.noResultsForDiscountSearch2 }}</div>
          <button class="back-button" @click="backToFlyer">{{ content.search.backButtonText }}</button>
        </div>
        <div v-else>
          {{ content.search.noResultsMessage1 }}&nbsp;
					<span class="queryMsg">{{ formattedQuery }}</span>
					<div>{{ content.search.noResultsMessage2 }}</div>
					<div class="no-results-suggestions">
						<div v-for="item in content.search.noResults" :key="item.title" class="suggestion-element">
							<span class="no-results-title">{{ item.title }}</span>
							<p class="no-results-message">{{ item.message }}</p>
					</div>
					</div>
          <button class="back-button" @click="backToFlyer">{{ content.search.backButtonText }}</button>
        </div>
			</div>
			<scroll-container
					v-else-if="hits.length"
					id="search-scroll-container"

					:orientation="TiledView ? 'vertical' : flyerOrientation"
					:fit-axis="TiledView
						? 'x'
						: (flyerOrientation === 'horizontal' ? 'y' : 'x')"

					:enable-scroll-buttons="displayMode !== 'mobile'"
					:enable-scroll-bars="!branding.disableScrollBars"
					:zoom-level="zoomLevel"
					:max-width="TiledView && flyerOrientation === 'horizontal' ? 2000 : 900"

					class="search-results"
					@contentResize="onResize"
					@resize="onScrollContainerResize"
					>

				<template  v-if="TiledView">
				<SearchResultTiledView  class="section-container" id="card-view" :search-results="true" root-scroll-container="search-scroll-container"
					:is-grid-view="TiledView" :flyer-pages=[...hits]>
					</SearchResultTiledView>

				</template>
				<template v-else>
					<search-result-renderer :pages="resultsPage" />
				</template>
				<!-- <responsive-grid id="resp-grid" :search-results="true" root-scroll-container="search-scroll-container"
					:flyer-pages="generateResultsPageFromHits(hits)"></responsive-grid> -->
			</scroll-container>
		</div>
		<!-- FeatureToast  /-->
		<!-- <button @click="resetFilters">Back To<br v-if="!columnView"> Current Flyer</button> -->
	</div>
	<div v-else :class="wrapperClasses" class="wpr search-results-wrapper">
		<div v-if="noResults" class="no-results">
      <div v-if="anyFilterSelected">

        {{ content.search.noResultsForDiscountSearch1 }}&nbsp;
        <div>{{ content.search.noResultsForDiscountSearch2 }}</div>
        <button class="back-button" @click="backToFlyer">{{ content.search.backButtonText }}</button>
      </div>
      <div v-else>
        {{ content.search.noResultsMessage1 }}&nbsp;
        <span class="queryMsg">{{ formattedQuery }}</span>
        <div>{{ content.search.noResultsMessage2 }}</div>
        <div class="no-results-suggestions">
          <div v-for="item in content.search.noResults" :key="item.title" class="suggestion-element">
            <span class="no-results-title">{{ item.title }}</span>
            <p class="no-results-message">{{ item.message }}</p>
          </div>
        </div>
        <button class="back-button" @click="backToFlyer">{{ content.search.backButtonText }}</button>
      </div>
		</div>
		<!-- <scroll-container
					v-else
					id="search-scroll-container"

					:orientation="TiledView ? 'vertical' : flyerOrientation"
					:fit-axis="TiledView
						? 'x'
						: (flyerOrientation === 'horizontal' ? 'y' : 'x')"

					:enable-scroll-buttons="displayMode !== 'mobile'"
					:enable-scroll-bars="!branding.disableScrollBars"
					:zoom-level="zoomLevel"
					:max-width="TiledView && flyerOrientation === 'horizontal' ? 2000 : 900"

					class="search-results"
					@contentResize="onResize"
					@resize="onScrollContainerResize"
					> -->
					<scroll-container v-else id="search-scroll-container"
					:align="flyerOrientation == 'vertical' ? 'center' : 'left'"
					:enable-scroll-buttons="displayMode != 'mobile'"
					:enable-scroll-bars="!branding.disableScrollBars"
					:fit-axis="TiledView
						? 'x'
						: (flyerOrientation === 'horizontal' ? 'y' : 'x')"
					:orientation="TiledView ? 'vertical' : flyerOrientation" :zoom-level="zoomLevel" class="search-results" @contentResize="onResize"
			@resize="onScrollContainerResize"
			:max-width="TiledView && flyerOrientation === 'horizontal' ? 2000 : 900">
			<template v-if="TiledView">

						<!-- Card View Component -->
						<SearchResultTiledView    class="section-container" id="card-view" :search-results="true" root-scroll-container="search-scroll-container"
											 :is-grid-view="TiledView" v-bind:flyer-pages=[...hits]>
						</SearchResultTiledView>

				</template>
				<template v-else>
					<!--call reposnsive in flyerview-->
				<!--SearchResultFlyerView id="resp-grid" :search-results="true" root-scroll-container="search-scroll-container"
				v-bind:flyer-pages="resultsPage"></SearchResultFlyerView -->
					<search-result-renderer :pages="resultsPage" />
				</template>

			<!-- <responsive-grid id="resp-grid" :search-results="true" root-scroll-container="search-scroll-container"
				v-bind:flyer-pages="resultsPage"></responsive-grid> -->

			<!--flyer-page-renderer :page="resultsPage[0]" :force-row-count="4" :row-height="aspectRowHeight" :col-width="aspectColWidth" / -->
			<!-- grid-renderer :rows="4"  :row-height="364" :column-width="316" :items="filteredItems" / -->
			<!--responsive-grid id="resp-grid" :search-results="true" root-scroll-container="search-scroll-container"
			                 v-bind:flyer-pages="resultsPage"></responsive-grid -->
		</scroll-container>
	</div>
</template>

<script>
import SearchResultTiledView from "@/components/SearchResultTiledView";
import Page from "@/classes/Page";
import {mapActions, mapState, mapGetters} from 'vuex';
import ScrollContainer from "@/components/scroll-container/ScrollContainer";
import GridRenderer from "@/components/grid-renderer/GridRenderer.vue";

//import TiledViewToggleButton from '@/features/filters/TiledViewToggleButton.vue';

import GaplessGridLayout from "@/components/blockLayout/GaplessGridLayout.vue";
import {SEARCH_MODE_WITH_POSITIONS} from "@/store/modules/search";
import SearchResultRenderer from "@/components/page/SearchResultRenderer.vue";


export default {
	components: {
		SearchResultRenderer,
		// eslint-disable-next-line vue/no-unused-components
		GridRenderer,
		// eslint-disable-next-line vue/no-unused-components
		GaplessGridLayout,
		ScrollContainer,
		SearchResultTiledView: SearchResultTiledView,
		//tiledviewToggle: TiledViewToggleButton

	},

	props: ['scale'],
	mounted() {
		this.triggerEvent({event: 'event_search_result_change', data: this});
		if (this.TiledView) {
			this.setManualZoom(true)
			  this.setZoomLevel(0)
		}
	},

	computed: {
		...mapState(['columnView']),
		...mapState('search', ['showMobileSearchBar', 'saving','pricing' ,'categories', 'subCategories', 'hits', 'loading']),
		...mapGetters('search', ['filteredItems', "searchMode", 'searchResults']),
		...mapGetters('screen', ['flyerOrientation', 'displayMode']),
		...mapGetters('scale', ['defPage', 'defPageGrid', 'unitWidth', 'unitHeight']),
		...mapState('scale', ['zoomLevel']),
		...mapState('toast', ['tourVisible']),
		...mapGetters(['content', 'language', 'findBlocksBySKUs', 'storeId', 'dealId', 'isCTC']),
		...mapGetters('filters', ['searchQuery', 'filters']),
		...mapGetters('config', ['features', 'branding']),
		...mapGetters(['TiledView']),
		 ...mapGetters('inlineDrawers', ['isFilterSortWindowOpen']),


		query() {

			return this.searchQuery?.text;
		},

    formattedQuery() {
			const isEnglish = this.getUrlParameter('language') === 'en';
			const quoteStart = isEnglish ? '"' : ' <<';
			const quoteEnd = isEnglish ? '"' : '>>';
			return `${quoteStart}${this.query ? this.query : ''}${quoteEnd}.`;
		},

    wrapperClasses() {
			return {
				'col': this.columnView,
				'search-open': this.showMobileSearchBar,
				disabled: this.tourVisible
			};
		},

		resultsPage() {

const items = this.hits.length ? this.findBlocksBySKUs(this.hits.map(hit => hit.sku)) : this.filteredItems;
			const page = this.searchMode === SEARCH_MODE_WITH_POSITIONS ? this.searchResults?.page : Page.GenerateSearchPage(items, this.defPage.type || this.defPage, this.defPageGrid);
			if (!page) return [];
			page.name = "search_results";
			return [page];
		},

		noResults() {
			return !this?.resultsPage?.[0]?.blocks?.length;
		},

    anyFilterSelected() {
      const q = this.searchQuery;
      return Object.keys(q).some(k => k !== 'text' && k !== 'Sort');
    },

    isDropdownDiscountFilter() {
      if (!this.filters || this.isCTC) return false;
      const discountFilter = this.filters.find(filter => filter.name === 'saving');
      return discountFilter && discountFilter.mode === 'dropdown';
    },

    isDropdownPricingFilter() {
      if (!this.filters || this.isCTC) return false;
      const pricingFilter = this.filters.find(filter => filter.name === 'pricing');
      return pricingFilter && pricingFilter.mode === 'dropdown';
    },
	},
	methods: {
		...mapActions('scale', ['updateScale']),
		...mapActions('events', ['triggerEvent']),
		...mapActions('scale', ['setZoomLevel', 'zoomOut', 'zoomNormal', 'setManualZoom']),
    ...mapActions('filters', ['clearFilters']),

    backToFlyer() {
      this.clearFilters();
      // Return focus to the search input after clearing.
      // Wait two animation frames before focusing — refocusing too early races
      // the scroll-container's resize recalculation and leaves the flyer
      // unscrollable until a page refresh.
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const searchInput = document.querySelector('.search-bar input');
            if (searchInput) searchInput.focus({ preventScroll: true });
          });
        });
      });
		},

    clearDiscountFilter() {
      const discountButton = document.querySelector('.bp-dropdown.range-dropdown.filter-dropdown .bp-dropdown__btn');
      if (discountButton) {
        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        discountButton.dispatchEvent(clickEvent);
      }
    },

		generateResultsPageFromHits(hits) {

			const skus = hits.map(hit => hit.defaultSku);
			console.log('SKUs:', skus)
			const page = Page.GenerateSearchPage(this.findBlocksBySKUs(skus), this.defPage.type || this.defPage, this.defPage.grids);
			return [page];
		},

		onScrollContainerResize(scroller) {
			this.updateScale(scroller._sz.getScale());
		},

		onResize() {
			//scroller.scroll({x: 0, y: 0});
		},

		getUrlParameter(name) {
			name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
			var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
			var results = regex.exec(window.location.search);
			return results === null
				? ""
				: decodeURIComponent(results[1].replace(/\+/g, " "));
		},

		checkIfScrolling() {
			return document.querySelector('.search-results .section-container')
		}
	},
	watch: {
		hits(newVal) {
			//console.log('Hits:', h);
			if (newVal && newVal.length && !this.TiledView) {
				this.$store.dispatch('setTiledView', true);
			}
		},
		//commented this line as it was
		//  causing the Vue reactivity system to do extra work on every filter change and make 
		//UI slow and freezed
		// resultsPage(p) {
		// 	console.log("Results Changed!:", p);
		// 	this.triggerEvent({event: 'event_search_result_change', data: this});
		// }
	}
}
</script>

<style scoped>
	.toggle-container {
	width: 100%;
	margin: 0 auto;
	border-bottom: 1px solid #E5E5E5;
	background: #F5F5F5;

	}
.wpr {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	z-index: 98;
	background-color: rgba(0, 0, 0, 0.5);
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
}

.wpr.search-open {
	top: 201px;
}

.wpr.col {
	flex-direction: column;
}

.queryMsg {
	color: #000000;
}

.queryMsgSubheader {
	font-size: 18px !important;
}


.search-results {
	height: calc(100% - 20px);
	width: 100%;
	background-color: #fff;
	padding-bottom: 26px;
}

.no-results {
  display: flex;
	font-size: 26px;
	width: 100%;
	height: 100%;
	background-color: #fff;
	justify-content: center;
	font-weight: bolder;
	padding-top: 150px;
}

.no-results-suggestions {
	display: flex;
  flex-direction: column;
	align-items: flex-start;
	margin-top: 0px;
}

.suggestion-element {
	padding-top: 10px;
}

.no-results-title {
  font-size: 16px;
	color: #000000;
}

.no-results-message {
	font-size: 16px;
	font-weight: normal !important;
}

.col .search-results {
	width: 100%;
	max-width: inherit;
}

.col .search-results>* {
	justify-content: center;
	transform-origin: top;
	margin-bottom: 20px;
}

button {
	background-color: #ED1C24;
	color: #FFF;
	border: 1px solid #AFAFAF;
	border-radius: 4px;
	font-size: 14px;
	font-weight: 700;
	padding: 10px 50px;
	margin: auto;
	white-space: nowrap;
	cursor: pointer;
}

button {
	background-color: #457a3e;
	color: #FFF;
	border: none;
	border-radius: 8px;
	font-size: 14px;
	font-weight: normal;
	padding: 10px 30px;
	margin: auto;
	white-space: nowrap;
	cursor: pointer;
	margin-top: 40px;
}

button:hover {
	color: #FFF;
}

.discount-button {
	margin-left: 10px;
}

@media (max-width: 1024px) {
	.queryMsgSubheader {
		font-size: 16px !important;
	}

	.no-results {
		font-size: 24px;
		padding: 100px 35px;
	}

	.search-results {
		width: 100%;
		max-width: inherit;
	}
}

.search-results-wrapper>div {
	height: 100%;
	width: 100%;
}
</style>
